import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import tw from "twin.macro";

import styled from "styled-components";
const Container = tw.div`relative md:mx-72 mx-4  text-black -mt-12`;

const FormContainer = tw.form` md:flex p-6 justify-between bg-gray-800`;

const TitleContainer = tw.div` `;
const Title = tw.div`bg-blue-400 p-3 w-80 text-lg font-semibold text-white rounded-t-lg`;

const ButtonContainer = styled.button`
  background-color: #60a5fa;
  color: white;
  font-weight: 600;
  font-size: 16px;
  padding: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
  width: 100%;
`;

const OptionContainer = styled.select`
  font-size: 14px;
  padding: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid;
  ::placeholder {
    color: black;
  }
`;

const Option = styled.option`
  font-size: 14px;
  padding: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid;
  ::placeholder {
    color: black;
  }
`;

const Input = styled.input`
  font-size: 14px;
  padding: 10px;
  margin-right: 30px;
  margin-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid;
  ::placeholder {
    color: black;
  }
`;

export default () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    alert("Callback Request Sent");
    emailjs
      .sendForm(
        "service_1nomxy7",
        "template_95u9w49",
        form.current,
        "LPQqxrAw5NkUVSZei"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <Container>
      <TitleContainer>
        <Title>Request Service Today</Title>
      </TitleContainer>
      <FormContainer ref={form} onSubmit={sendEmail}>
        <Input
          type="email"
          name="user_email"
          placeholder="Your Email Address"
          required
        />
        <Input
          type="text"
          name="phone_number"
          placeholder="Phone Number"
          required
        />

        <OptionContainer
          class="location"
          name="requested_service"
          id="uiLocations"
        >
          <Option id="opt1" value="Insulation">
            Insulation
          </Option>
          <Option id="opt2" value="Drywall">
            Drywall
          </Option>
          <Option id="opt3" value="Mud and Tape">
            Mud and Tape
          </Option>
          <Option id="opt4" value="Paint">
            Paint
          </Option>
        </OptionContainer>
        <ButtonContainer>REQUEST CALL BACK</ButtonContainer>
      </FormContainer>
    </Container>
  );
};
